import { render, staticRenderFns } from "./the-footer.vue?vue&type=template&id=548da726"
import script from "./the-footer.vue?vue&type=script&lang=js"
export * from "./the-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports